import React from 'react';
import strings from "../../../localization";
import { getError, hasError } from "../../../functions/Validation";
import { Button, TextField, FormLabel, FormControlLabel, Radio, FormControl, RadioGroup, Drawer, Checkbox } from "@material-ui/core";
import DatePickerControl from '../../controls/DatePickerControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import NumberFormat from 'react-number-format';
import { stringToDate } from '../../../util/DateUtil';
import moment from 'moment';

const ArrangedPlotRentForm = ({
  onSubmit,
  onCancel,
  onChange,
  errors,
  data,
  isDisabled,
  handleChange,
  handleContractCheckboxChange,
  onAutocompleteChange,
  handleTextInputChange,
  submitters,
  submitters2,
  submitter,
  submitter2,
  graveyards,
  graveSites,
  stonecutters,
  flag,
  date,
  flagAddNewSubmitter,
  flagAddNewSubmitter2,
  renderAddCitizen,
  flagMarginValid,
  flagMarginValid2,
  typedInGraveSite,
  keyPress,
  keyPressBackspace,
}) => {
  let renderAddCitizenButton = {
    marginLeft: "289px",
    marginTop: "-114px",
    paddingBottom: "-300px"
  }


  return (
    <form id='user-form'>
      <TextField
        label={strings.arrangedPlotRent.form.mainBookOfBuried + "*"}
        error={hasError(errors, 'mainBookOfBuriedString')}
        helperText={getError(errors, 'mainBookOfBuriedString')}
        fullWidth
        autoFocus
        name='mainBookOfBuriedString'
        onChange={onChange}
        margin="normal"
        defaultValue={date}
        value={data.mainBookOfBuriedString}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />


      {((data.submitter && flag == "edit") || (flag == "add") || (data.submitter && flag == "view")) &&
        <Autocomplete
          key={data.submitter ? (data.submitter.id || data.submitter.personalNumber) : 'submitter-empty'}
          id={"submitter"}
          name={"submitter"}
          options={submitters}
          noOptionsText={""}
          getOptionLabel={option => option.personalNumber}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.personalNumber}
              margin="normal"
              style={{ width: 275 }}
              name={"submitter"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
              error={hasError(errors, 'submitter')}
              helperText={getError(errors, 'submitter')}
            />
          )}
          error={hasError(errors, 'submitter')}
          helperText={getError(errors, 'submitter')}
          disabled={isDisabled}
          value={data.submitter}
        />
      }
      {((!data.submitter && flag == "edit") || (!data.submitter && flag == "view")) &&
        <Autocomplete
          key={'submitter-empty'}
          id={"submitter"}
          name={"submitter"}
          options={submitters}
          getOptionLabel={option => option.personalNumber}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.personalNumber}
              margin="normal"
              style={{ width: 275 }}
              name={"submitter"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
              error={hasError(errors, 'submitter')}
              helperText={getError(errors, 'submitter')}
            />
          )}
          error={hasError(errors, 'submitter')}
          helperText={getError(errors, 'submitter')}
          disabled={isDisabled}
          value={data.submitter}
        />
      }

      {flagAddNewSubmitter == true && flagMarginValid == true &&
        <div className='submit-container'>
          <Button variant="contained" color="secondary" onClick={() => renderAddCitizen('submitter')} style={renderAddCitizenButton}>
            {strings.arrangedPlotRent.form.addNewSubmitter}
          </Button>

        </div>
      }

      {flagAddNewSubmitter == true && flagMarginValid == false &&
        <div className='submit-container'>
          <Button variant="contained" color="secondary" onClick={() => renderAddCitizen('submitter')} style={renderAddCitizenButton}>
            {strings.arrangedPlotRent.form.addNewSubmitter}
          </Button>
          <div class="renderAddCitizenButtonNotValidPersonalNumber">
            {strings.citizen.messages.CITIZEN_PERSONAL_NUMBER_NOT_VALID}
          </div>
        </div>
      }

      <TextField
        label={strings.arrangedPlotRent.form.submitterName}
        error={hasError(errors, 'nameSurnameSubmitter')}
        helperText={getError(errors, 'nameSurnameSubmitter')}
        fullWidth
        name='nameSurnameSubmitter'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter.nameSurnameSubmitter}
        value={submitter.nameSurnameSubmitter}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterAddress}
        error={hasError(errors, 'addressSubmitter')}
        helperText={getError(errors, 'addressSubmitter')}
        fullWidth
        name='addressSubmitter'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter.addressSubmitter}
        value={submitter.addressSubmitter}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterMunicipality}
        error={hasError(errors, 'municipalitySubmitter')}
        helperText={getError(errors, 'municipalitySubmitter')}
        fullWidth
        name='municipalitySubmitter'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter.municipalitySubmitter}
        value={submitter.municipalitySubmitter}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterTelephone}
        error={hasError(errors, 'telephoneSubmitter')}
        helperText={getError(errors, 'telephoneSubmitter')}
        fullWidth
        name='telephoneSubmitter'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter.telephoneSubmitter}
        value={submitter.telephoneSubmitter}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      {((data.submitter2 && flag == "edit") || (flag == "add") || (data.submitter2 && flag == "view")) &&
        <Autocomplete
          key={data.submitter2 ? (data.submitter2.id || data.submitter2.personalNumber) : 'submitter2-empty'}
          id={"submitter2"}
          name={"submitter2"}
          options={submitters2}
          getOptionLabel={option => option.personalNumber}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.personalNumber2}
              margin="normal"
              style={{ width: 275 }}
              name={"submitter2"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.submitter2}
        />
      }
      {((!data.submitter2 && flag == "edit") || (!data.submitter2 && flag == "view")) &&
        <Autocomplete
          key={'submitter2-empty'}
          id={"submitter2"}
          name={"submitter2"}
          options={submitters2}
          getOptionLabel={option => option.personalNumber}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.personalNumber2}
              margin="normal"
              style={{ width: 275 }}
              name={"submitter2"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.submitter2}
        />
      }
      {flagAddNewSubmitter2 == true && flagMarginValid2 == true &&
        <div className='submit-container'>
          <Button variant="contained" color="secondary" onClick={() => renderAddCitizen('submitter2')} style={renderAddCitizenButton}>
            {strings.arrangedPlotRent.form.addNewSubmitter}
          </Button>

        </div>
      }

      {flagAddNewSubmitter2 == true && flagMarginValid2 == false &&
        <div className='submit-container'>
          <Button variant="contained" color="secondary" onClick={() => renderAddCitizen('submitter2')} style={renderAddCitizenButton}>
            {strings.arrangedPlotRent.form.addNewSubmitter}
          </Button>
          <div class="renderAddCitizenButtonNotValidPersonalNumber">
            {strings.citizen.messages.CITIZEN_PERSONAL_NUMBER_NOT_VALID}
          </div>
        </div>
      }

      <TextField
        label={strings.arrangedPlotRent.form.submitterName2}
        error={hasError(errors, 'nameSurnameSubmitter2')}
        helperText={getError(errors, 'nameSurnameSubmitter2')}
        fullWidth
        name='nameSurnameSubmitter2'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter2.nameSurnameSubmitter2}
        value={submitter2.nameSurnameSubmitter2}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterAddress2}
        error={hasError(errors, 'addressSubmitter2')}
        helperText={getError(errors, 'addressSubmitter2')}
        fullWidth
        name='addressSubmitte2r'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter2.addressSubmitter2}
        value={submitter2.addressSubmitter2}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterMunicipality2}
        error={hasError(errors, 'municipalitySubmitter2')}
        helperText={getError(errors, 'municipalitySubmitter2')}
        fullWidth
        name='municipalitySubmitter2'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter2.municipalitySubmitter2}
        value={submitter2.municipalitySubmitter2}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.submitterTelephone2}
        error={hasError(errors, 'telephoneSubmitter2')}
        helperText={getError(errors, 'telephoneSubmitter2')}
        fullWidth
        name='telephoneSubmitter2'
        onChange={onChange}
        margin="normal"
        defaultValue={submitter2.telephoneSubmitter2}
        value={submitter2.telephoneSubmitter2}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={true}
      />
      <TextField
        label={strings.arrangedPlotRent.form.horizontal}
        error={hasError(errors, 'horizontal')}
        helperText={getError(errors, 'horizontal')}
        fullWidth
        name='horizontal'
        onChange={onChange}
        margin="normal"
        defaultValue={data.horizontal}
        value={data.horizontal}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.arrangedPlotRent.form.vertical}
        error={hasError(errors, 'vertical')}
        helperText={getError(errors, 'vertical')}
        fullWidth
        name='vertical'
        onChange={onChange}
        margin="normal"
        defaultValue={data.vertical}
        value={data.vertical}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.arrangedPlotRent.form.horizontalNumber}
        error={hasError(errors, 'horizontalNumber')}
        helperText={getError(errors, 'horizontalNumber')}
        fullWidth
        name='horizontalNumber'
        onChange={onChange}
        margin="normal"
        defaultValue={data.horizontalNumber}
        value={data.horizontalNumber}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <TextField
        label={strings.arrangedPlotRent.form.verticalNumber}
        error={hasError(errors, 'verticalNumber')}
        helperText={getError(errors, 'verticalNumber')}
        fullWidth
        name='verticalNumber'
        onChange={onChange}
        margin="normal"
        defaultValue={data.verticalNumber}
        value={data.verticalNumber}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {((data.graveyard && flag == "edit") || (flag == "add") || (data.graveyard && flag == "view")) &&
        <Autocomplete
          id={"graveyard"}
          name={"graveyard"}
          options={graveyards}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.graveyard + "*"}
              error={hasError(errors, 'graveyard')}
              helperText={getError(errors, 'graveyard')}
              margin="normal"
              fullWidth
              name={"graveyard"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.graveyard}
        />
      }
      {((!data.graveyard && flag == "edit") || (!data.graveyard && flag == "view")) &&
        <Autocomplete
          id={"graveyard"}
          name={"graveyard"}
          options={graveyards}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.graveyard + "*"}
              error={hasError(errors, 'graveyard')}
              helperText={getError(errors, 'graveyard')}
              margin="normal"
              fullWidth
              name={"graveyard"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.graveyard}
        />

      }
      {((data.graveSite && flag == "edit") || (flag == "add") || (data.graveSite && flag == "view")) && ((data.graveyard != undefined && data.graveyard != null)) &&
        <Autocomplete
          noOptionsText={(typedInGraveSite != undefined ? strings.mainBookOfBuried.form.create + typedInGraveSite : "")}
          onKeyPress={keyPress}
          id={"graveSite"}
          name={"graveSite"}
          options={graveSites}
          getOptionLabel={option => option.code}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.graveSite + "*"}
              error={hasError(errors, 'graveSite')}
              helperText={getError(errors, 'graveSite')}
              margin="normal"
              fullWidth
              name={"graveSite"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.graveSite}
          disableClearable={true}
          onKeyDown={keyPressBackspace}
        />
      }
      {((!data.graveSite && flag == "edit") || (!data.graveSite && flag == "view")) && (data.graveyard != undefined && data.graveyard != null) &&
        <Autocomplete
          noOptionsText={(typedInGraveSite != undefined ? strings.mainBookOfBuried.form.create + typedInGraveSite : "")}
          onKeyPress={keyPress}
          id={"graveSite"}
          name={"graveSite"}
          options={graveSites}
          getOptionLabel={option => option.code}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.graveSite + "*"}
              error={hasError(errors, 'graveSite')}
              helperText={getError(errors, 'graveSite')}
              margin="normal"
              fullWidth
              name={"graveSite"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.graveSite}
          disableClearable={true}
          onKeyDown={keyPressBackspace}
        />
      }

      {(data.graveyard == undefined || data.graveyard == null) &&
        <Autocomplete
          id={"graveSite"}
          name={"graveSite"}
          options={graveSites}
          getOptionLabel={option => option.code}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.graveSite + "*"}
              error={hasError(errors, 'graveSite')}
              helperText={getError(errors, 'graveSite')}
              margin="normal"
              fullWidth
              name={"graveSite"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={true}
          value={null}
          disableClearable={true}
        />
      }

      <FormControl component="fieldset">
        <FormLabel className="checkboxLabel"> {strings.arrangedPlotRent.form.deceasedInside} </FormLabel>
        <RadioGroup name="deceasedInside" value={(data.deceasedInside == true || data.deceasedInside == "true") ? "true" : "false"} onChange={handleChange} className="radioGroup">
          <FormControlLabel value={"true"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.arrangedPlotRent.form.yes}</span>} />
          <FormControlLabel value={"false"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.arrangedPlotRent.form.no}</span>} />
        </RadioGroup>
      </FormControl>
      <TextField
        label={strings.arrangedPlotRent.form.tombstoneType}
        error={hasError(errors, 'tombstoneType')}
        helperText={getError(errors, 'tombstoneType')}
        fullWidth
        name='tombstoneType'
        onChange={onChange}
        margin="normal"
        defaultValue={data.tombstoneType}
        value={data.tombstoneType}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {(data.tombstoneFromDateString != undefined && data.tombstoneFromDateString != null && data.tombstoneFromDateString != "") &&
        <TextField
          label={strings.arrangedPlotRent.form.tombstoneFromDateString}
          fullWidth
          name='tombstoneFromDateString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.tombstoneFromDateString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      <DatePickerControl
        label={strings.arrangedPlotRent.form.tombstoneFromDate}
        error={getError(errors, 'tombstoneFromDate')}
        hasError={hasError(errors, 'tombstoneFromDate')}
        helperText={getError(errors, 'tombstoneFromDate')}
        placeholder={strings.arrangedPlotRent.form.tombstoneFromDate}
        name='tombstoneFromDate'
        onChange={onChange}
        date={data.tombstoneFromDate ? new Date(data.tombstoneFromDate) : data.tombstoneFromDate}
        isClearable={true}
        dateFormat='dd/MM/yyyy'
        disabled={isDisabled}
      />
      {((data.stonecutter && flag == "edit") || (flag == "add") || (data.stonecutter && flag == "view")) &&
        <Autocomplete
          id={"stonecutter"}
          name={"stonecutter"}
          options={stonecutters}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.stonecutter}
              margin="normal"
              fullWidth
              name={"stonecutter"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.stonecutter}
        />
      }
      {((!data.stonecutter && flag == "edit") || (!data.stonecutter && flag == "view")) &&
        <Autocomplete
          id={"stonecutter"}
          name={"stonecutter"}
          options={stonecutters}
          getOptionLabel={option => option.name}
          onChange={onAutocompleteChange}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={strings.arrangedPlotRent.form.stonecutter}
              margin="normal"
              fullWidth
              name={"stonecutter"}
              onChange={handleTextInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
          disabled={isDisabled}
          value={data.stonecutter}
        />
      }
      {(data.expiryDateString != undefined && data.expiryDateString != null && data.expiryDateString != "") &&
        <TextField
          label={strings.arrangedPlotRent.form.expiryDateString}
          fullWidth
          name='expiryDateString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.expiryDateString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      {(flag == 'add' || flag == 'view') &&
        <DatePickerControl
          label={strings.arrangedPlotRent.form.expiryDate}
          error={getError(errors, 'expiryDate')}
          hasError={hasError(errors, 'expiryDate')}
          helperText={getError(errors, 'expiryDate')}
          placeholder={strings.arrangedPlotRent.form.expiryDate}
          name='expiryDate'
          onChange={onChange}
          //date={data.expiryDate ? new Date(data.expiryDate) : data.expiryDate}
          date={data.expiryDate ? stringToDate(data.expiryDateString) > moment(data.expiryDate, 'YYYY-MM-DD') ? stringToDate(data.expiryDateString).toDate() : new Date(data.expiryDate) : data.expiryDate}
          isClearable={true}
          dateFormat='dd/MM/yyyy'
          disabled={isDisabled}
        />
      }
      {(flag == 'edit') &&
        <DatePickerControl
          label={strings.arrangedPlotRent.form.expiryDate}
          error={getError(errors, 'expiryDate')}
          hasError={hasError(errors, 'expiryDate')}
          helperText={getError(errors, 'expiryDate')}
          placeholder={strings.arrangedPlotRent.form.expiryDate}
          name='expiryDate'
          onChange={onChange}
          date={data.expiryDate ? new Date(data.expiryDate) : data.expiryDate}
          isClearable={true}
          dateFormat='dd/MM/yyyy'
          disabled={isDisabled}
        />
      }
      <TextField
        label={strings.arrangedPlotRent.form.contractNumber}
        error={hasError(errors, 'contractNumber')}
        helperText={getError(errors, 'contractNumber')}
        fullWidth
        name='contractNumber'
        onChange={onChange}
        margin="normal"
        defaultValue={data.contractNumber}
        value={data.contractNumber}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      <FormControlLabel
        control={
          <Checkbox
            name="contractDoesNotExist"
            checked={data.contractDoesNotExist === true}
            onChange={handleContractCheckboxChange}
            disabled={isDisabled}
          />
        }
        label={<span className="formControlLabel">{strings.arrangedPlotRent.form.contractDoesNotExist}</span>}
      />
      <FormControlLabel
        control={
          <Checkbox
            name="contractExists"
            checked={data.contractExists === true}
            onChange={handleContractCheckboxChange}
            disabled={isDisabled}
          />
        }
        label={<span className="formControlLabel">{strings.arrangedPlotRent.form.contractExists}</span>}
      />
      {(data.contractDateString != undefined && data.contractDateString != null && data.contractDateString != "") &&
        <TextField
          label={strings.arrangedPlotRent.form.contractDateString}
          fullWidth
          name='contractDateString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.contractDateString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      <DatePickerControl
        label={strings.arrangedPlotRent.form.contractDate}
        error={getError(errors, 'contractDate')}
        hasError={hasError(errors, 'contractDate')}
        helperText={getError(errors, 'contractDate')}
        placeholder={strings.arrangedPlotRent.form.contractDate}
        name='contractDate'
        onChange={onChange}
        //date={data.contractDate ? new Date(data.contractDate) : data.contractDate}
        date={data.contractDate ? stringToDate(data.contractDateString) > moment(data.contractDate, 'YYYY-MM-DD') ? stringToDate(data.contractDateString).toDate() : new Date(data.contractDate) : data.contractDate}
        isClearable={true}
        dateFormat='dd/MM/yyyy'
        disabled={isDisabled}
      />
      
      <TextField
        label={strings.arrangedPlotRent.form.paymentNumber}
        error={hasError(errors, 'paymentNumber')}
        helperText={getError(errors, 'paymentNumber')}
        fullWidth
        name='paymentNumber'
        onChange={onChange}
        margin="normal"
        defaultValue={data.paymentNumber}
        value={data.paymentNumber}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {(data.dateOfRentString != undefined && data.dateOfRentString != null && data.dateOfRentString != "") &&
        <TextField
          label={strings.arrangedPlotRent.form.dateOfRentString}
          fullWidth
          name='dateOfRentString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.dateOfRentString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      <DatePickerControl
        label={strings.arrangedPlotRent.form.dateOfRent + "*"}
        error={getError(errors, 'dateOfRent')}
        hasError={hasError(errors, 'dateOfRent')}
        helperText={getError(errors, 'dateOfRent')}
        placeholder={strings.arrangedPlotRent.form.dateOfRent}
        name='dateOfRent'
        onChange={onChange}
        //date={data.dateOfRent ? new Date(data.dateOfRent) : data.dateOfRent}
        date={data.dateOfRent ? stringToDate(data.dateOfRentString) > moment(data.dateOfRent, 'YYYY-MM-DD') ? stringToDate(data.dateOfRentString).toDate() : new Date(data.dateOfRent) : data.dateOfRent}
        isClearable={true}
        dateFormat='dd/MM/yyyy'
        disabled={isDisabled}
      />

{(data.dateOfCancellationString != undefined && data.dateOfCancellationString != null && data.dateOfCancellationString != "") &&
        <TextField
          label={strings.arrangedPlotRent.form.dateOfCancellation}
          fullWidth
          name='dateOfCancellationString'
          onChange={handleTextInputChange}
          margin="normal"
          value={data.dateOfCancellationString}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={true}
        />
      }
      {(flag == "add" || flag == "edit" || flag == "view") &&
        <NumberFormat
          thousandSeparator={true} className="" inputmode="numeric" displayType="numeric"
          customInput={TextField}
          type="text"
          label={strings.arrangedPlotRent.form.amount}
          error={hasError(errors, 'amount')}
          helperText={getError(errors, 'amount')}
          fullWidth
          name='amount'
          onChange={onChange}
          margin="normal"
          defaultValue={data.amount}
          value={data.amount}
          InputLabelProps={{
            shrink: true,
          }}
          disabled={isDisabled}
          placeholder="0.00"
        />
      }

      <FormControl component="fieldset">
        <FormLabel className="checkboxLabel"> {strings.arrangedPlotRent.form.ban} </FormLabel>
        <RadioGroup name="ban" value={(data.z == true || data.z == "true") ? "true" : "false"} onChange={handleChange} className="radioGroup">
          <FormControlLabel value={"true"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.arrangedPlotRent.form.yes}</span>} />
          <FormControlLabel value={"false"} disabled={isDisabled} control={<Radio />} label={<span className="formControlLabel">{strings.arrangedPlotRent.form.no}</span>} />
        </RadioGroup>
      </FormControl>

      <TextField
        multiline={true}
        // rowsMax={5}
        label={strings.arrangedPlotRent.form.note}
        error={hasError(errors, 'note')}
        helperText={getError(errors, 'note')}
        fullWidth
        name='note'
        onChange={onChange}
        margin="normal"
        defaultValue={data.note}
        value={data.note}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={isDisabled}
      />
      {
        !isDisabled &&
        <div className='submit-container'>
          <Button variant="contained" color="primary" onClick={onSubmit}>
            {strings.arrangedPlotRent.form.ok}
          </Button>
          <Button variant="contained" color="secondary" onClick={onCancel}>
            {strings.arrangedPlotRent.form.cancel}
          </Button>
        </div>
      }
    </form>
  )
};

export default ArrangedPlotRentForm;